<template>
  <div>
    <div>
      <label for="changelog_entry_title" class="label">{{ $t('Title') }}</label>
      <input
        id="title"
        :placeholder="$t('Something short and descriptive')"
        v-model="titleContent"
        type="text"
        name="changelog_entry[title]"
        class="input"
      >
      <div v-if="errors.title" class="error_show">{{ $t('Please fill out this field.') }}</div>
    </div>
    <div class="mt-4">
      <label for="changelog_entry_body" class="label">{{ $t('Body') }}</label>
      <div class="changelog-editor mt-1">
        <RichTextEditor
          v-model="editorContent"
          input-id="changelog_entry_body"
          input-name="changelog_entry[body]"
          variant="full"
          :placeholder="$t('Write your changelog entry...')"
          :enable-embeds="true"
          :enable-image-upload="true"
          :enable-drafts="true"
          draft-id="changelog_entry"
          upload-url="/updates/images"
          :has-error="errors.body"
          @change="onEditorChange"
        />
      </div>
      <div v-if="errors.body" class="error_show">{{ $t('Please fill out this field.') }}</div>
    </div>
    <ChangelogSuggestModal
      :show-suggestion-modal="this.showSuggestionModal && this.subscription_valid == 'true'"
      @close-modal="closeModal()"
    />
  </div>
</template>

<script>
import { RichTextEditor } from "../components/rich_text_editor";
import EventBus from "event_bus";
import ChangelogSuggestModal from "./changelog_suggest_modal.vue";

export default {
  props: [
    "initial-content",
    "title",
    "show-ai-message",
    "subscription_valid",
    "show-suggestion-modal",
    "changelog-suggestions"
  ],

  data: function() {
    return {
      editorContent: this.initialContent || "",
      titleContent: this.title || "",
      errors: { title: false, body: false },
      showSuggestionModal: this.showSuggestionModal,
      posts: []
    };
  },

  components: {
    RichTextEditor,
    ChangelogSuggestModal
  },

  created() {
    EventBus.$on("errorChangelog", errors => {
      this.errors = errors;
    });
  },

  mounted() {
    EventBus.$emit("changelogTextAdded", {
      body: !!this.editorContent,
      title: !!this.titleContent
    });
  },

  methods: {
    onEditorChange(content) {
      EventBus.$emit("changelogTextAdded", {
        body: !!this.editorContent,
        title: !!this.titleContent
      });
    },

    suggestChangelog() {
      this.showSuggestionModal = true;
    },

    closeAIMessage() {
      Rails.ajax({
        url: `/changelog/remove_ai_message`,
        type: "POST",
        dataType: "json",
        beforeSend: function() {
          return true;
        },
        success: data => {
          document.getElementById("ai-message").remove();
        },
        error: (data, status) => {
          console.log(data);
        }
      });
    },

    closeModal() {
      this.showSuggestionModal = false;
    }
  },

  watch: {
    editorContent: {
      handler() {
        EventBus.$emit("changelogTextAdded", {
          body: !!this.editorContent,
          title: !!this.titleContent
        });
      }
    },
    titleContent: {
      handler() {
        EventBus.$emit("changelogTextAdded", {
          body: !!this.editorContent,
          title: !!this.titleContent
        });
      }
    }
  }
};
</script>

<style>
trix-editor:empty:not(:focus)::before {
  color: #a9a9a9;
}

.error_show {
  color: red;
  margin-left: 2px;
}

.trix-content .attachment--preview .attachment__caption {
  margin-top: 12px;
}
</style>
